import { Flex, Text } from '@applyboard/crystal-ui';

export type OfferClassificationCardProps = {
  selected: boolean;
  title: string;
  subtitle: string;
  onClick: () => void;
  'aria-label': string;
};

export function OfferClassificationCard(props: OfferClassificationCardProps) {
  const selectedColor = '#188149';
  const unselectedBorderColor = '#E4E7EC';

  return (
    <button
      type="button"
      onClick={props.onClick}
      aria-label={props['aria-label']}
      aria-pressed={props.selected}
      style={{
        flex: 1,
        display: 'flex',
        alignItems: 'flex-start',
        gap: 12,
        padding: 16,
        border: `1px solid ${props.selected ? selectedColor : unselectedBorderColor}`,
        borderRadius: 8,
        background: 'white',
        cursor: 'pointer',
        textAlign: 'left',
      }}
    >
      <span
        style={{
          width: 20,
          height: 20,
          borderRadius: '50%',
          border: `2px solid ${props.selected ? selectedColor : '#98A2B3'}`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
          marginTop: 2,
        }}
      >
        {props.selected && (
          <span
            style={{
              width: 10,
              height: 10,
              borderRadius: '50%',
              background: selectedColor,
            }}
          />
        )}
      </span>
      <Flex direction="column" gap={1}>
        <Text variant="bodyM">{props.title}</Text>
        <Text variant="bodyS" intent="secondary">
          {props.subtitle}
        </Text>
      </Flex>
    </button>
  );
}
